import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CCol,
  CContainer,
  CFormInput,
  CFormSelect,
  CFormText,
  CModal,
  CModalBody,
  CModalFooter,
  CRow,
} from '@coreui/react'
import '../cms/content.scss'
import 'simplebar/dist/simplebar.min.css'
import { isEmpty } from '../../utils/helper'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { getThumbnail, getVideoThumbnail } from '../../utils/helper'
import { AppContext } from 'src/views/context/app'
import useAxios from 'axios-hooks'
import { ASSET_API } from '../../utils/urls'
import Loading from 'react-fullscreen-loading'
import InfiniteScroll from 'react-infinite-scroll-component'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageNotFound from '../../../assets/image-not-found.jpg'
import { PAGE_SIZE } from 'src/views/utils/constants'

const AssetManager = ({ showModal, type, isTrailer = false, setAsset }) => {
  const accountId = localStorage.getItem('accountId')
  const [assetData, setAssetData] = useState([])
  const [searchText, setSearchText] = useState('')
  // const [durationFilter, setDurationFilter] = useState('')
  const [sizeFilter, setSizeFilter] = useState('')
  const [mappedFilter, setMappedFilter] = useState('empty')
  const [dateFilter, setDateFilter] = useState('')
  const [date, setDate] = useState('')
  const [selectedAsset, setSelectedAsset] = useState({})

  const { setLoader, loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [page, setPage] = useState(1)

  const [{ data: assetList, loading: assetListLoading }, assetListCall] = useAxios(
    {
      url: `${ASSET_API}?customer_id=${accountId}&asset_type=${type.toLowerCase()}&is_trailer=${isTrailer}&page_size=${PAGE_SIZE}`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    assetListCall()
  }, [])

  useEffect(() => {
    setLoader(assetListLoading)
  }, [assetListLoading])

  useEffect(() => {
    if (assetList && assetList.success) {
      let data = assetList.data

      page === 1 ? setAssetData(data) : setAssetData((assetData) => [...assetData, ...data])
    }
  }, [assetList])

  const onDateFilterChange = (date) => {
    const start = moment().startOf(`${date}`).unix()
    const end = moment().unix()
    setDate(date)
    setDateFilter(`${start}, ${end}`)
  }

  const applyFilter = () => {
    setPage(1)
    assetListCall({
      params: {
        page: 1,
        search_text: searchText,
        mapped_to_content: mappedFilter === 'empty' ? null : mappedFilter,
        size_in_between: sizeFilter,
        uploaded_in_between: dateFilter,
      },
    })
  }

  const handleAssetSelect = (asset) => {
    console.log(asset)
    setSelectedAsset(asset)
  }

  const handleSelect = () => {
    if (!isEmpty(selectedAsset)) {
      setAsset(selectedAsset)
      showModal(false)
    }
  }

  const resetFilters = () => {
    // setDurationFilter('')
    setSizeFilter('')
    setMappedFilter('empty')
    setDateFilter('')
    setDate('')
    setPage(1)
    assetListCall({
      params: {
        page_no: 1,
        search_text: searchText,
        mapped_to_content: null,
        size_in_between: '',
        uploaded_in_between: '',
      },
    })
  }

  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase()
    setSearchText(value)
    if (event.key === 'Enter') {
      setPage(1)
      assetListCall({
        params: {
          page_no: 1,
          search_text: `${value}`,
          mapped_to_content: mappedFilter === 'empty' ? null : mappedFilter,
          size_in_between: sizeFilter,
          uploaded_in_between: dateFilter,
        },
      })
    }
  }

  const handleClearSearch = () => {
    setSearchText('')
    setPage(1)
    assetListCall({
      params: {
        page_no: 1,
        search_text: ``,
        mapped_to_content: mappedFilter === 'empty' ? null : mappedFilter,
        size_in_between: sizeFilter,
        uploaded_in_between: dateFilter,
      },
    })
  }

  const handleNextPage = () => {
    assetListCall({
      params: {
        page_no: page + 1,
        search_text: searchText,
        mapped_to_content: mappedFilter === 'empty' ? null : mappedFilter,
        size_in_between: sizeFilter,
        uploaded_in_between: dateFilter,
      },
    })
    setPage((page) => page + 1)
  }

  return (
    <>
      <CModal scrollable size="xl" visible="true">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        {/* <CModalHeader></CModalHeader> */}
        <h5 className="mt-3" style={{ marginLeft: '1rem' }}>
          Add {type === 'VIDEO' ? (isTrailer ? 'Trailer' : 'Content') : type.toLowerCase()} from
          Asset Manager
        </h5>
        <CRow className="mt-3 mb-4">
          <CCol className="mr-5 d-md-flex justify-content-md-end align-items-center position-relative">
            <CFormInput
              type="text"
              style={{ width: '25rem', marginRight: '1rem' }}
              placeholder="Search..."
              size="sm"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyPress={(e) => handleSearch(e)}
            />
            {searchText && (
              <FontAwesomeIcon
                className="position-absolute"
                style={{ marginRight: '1.3rem', cursor: 'pointer' }}
                icon={faTimes}
                title="clear"
                onClick={handleClearSearch}
              />
            )}
          </CCol>
        </CRow>
        <CRow className="mt-2 mb-2">
          {/* <CCol style={{ marginLeft: '1rem' }}>
            <CFormSelect
              size="sm"
              placeholder="Content Duration"
              value={durationFilter}
              onChange={(e) => setDurationFilter(e.target.value)}
            >
              <option value="" selected disabled>
                Content Duration
              </option>
              <option value={5}>Less than 5 Minutes</option>
              <option value={30}>Less than 30 Minutes</option>
              <option value={119}>Less than 120 Minutes</option>
              <option value={120}>More than 120 Minutes</option>
            </CFormSelect>
          </CCol> */}
          <CCol style={{ marginLeft: '1rem' }} lg="3">
            <CFormSelect
              size="sm"
              placeholder="File Size"
              value={sizeFilter}
              onChange={(e) => setSizeFilter(e.target.value)}
            >
              <option value="" selected disabled>
                File Size
              </option>
              <option value={'0,524288000'}>Less than 500 MB</option>
              <option value={'0,1072693248'}>Less than 1 GB</option>
              <option value={'0,5367660544'}>Less than 5 GB</option>
              <option value={'5473566720,-1'}>More than 5 GB</option>
            </CFormSelect>
          </CCol>
          <CCol lg="3">
            <CFormSelect
              size="sm"
              placeholder="Mapped to Content"
              value={mappedFilter}
              onChange={(e) => setMappedFilter(e.target.value)}
            >
              <option value={'empty'} selected disabled>
                Mapped to Content
              </option>
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </CFormSelect>
          </CCol>
          <CCol lg="3">
            <CFormSelect
              size="sm"
              placeholder="Uploaded in"
              value={date}
              onChange={(e) => onDateFilterChange(e.target.value)}
            >
              <option value="" selected disabled>
                Uploaded in
              </option>
              <option value="day">Today</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
            </CFormSelect>
          </CCol>
          <CCol className="d-flex">
            <div className="mx-2">
              <CButton color="info" size="sm" className="text-white" onClick={applyFilter}>
                Apply
              </CButton>
            </div>
            <p
              className="mt-1"
              style={{ color: '#1976d2', cursor: 'pointer' }}
              onClick={resetFilters}
            >
              Reset Filter
            </p>
          </CCol>
        </CRow>

        <CModalBody>
          <div id="scrollableDiv" className="asset-manager-card px-2">
            <InfiniteScroll
              dataLength={assetData.length} //This is important field to render the next data
              next={handleNextPage}
              hasMore={assetList && assetList.total > page * PAGE_SIZE}
              style={{ overflowX: 'hidden' }}
              loader={<p>Loading...</p>}
              className="scrollbar-class"
              height={`58.5vh`}
              scrollableTarget="scrollableDiv"
            >
              <CRow>
                {!isEmpty(assetData) ? (
                  assetData.map((info, index) => (
                    <CCol
                      xs="3"
                      className={
                        selectedAsset?.asset_id === info.asset_id
                          ? 'card mt-2 mb-2 asset-selected'
                          : 'card mt-2 mb-2 image-card'
                      }
                      style={{ width: '12rem', marginLeft: '1.5rem' }}
                      key={index}
                      onClick={() => handleAssetSelect(info)}
                    >
                      <img
                        className="card-img-top"
                        src={
                          type.toLowerCase() === 'image'
                            ? getThumbnail(userSessionObj.session_data.cf_domain_name, info.s3_key)
                            : getVideoThumbnail(
                                userSessionObj.session_data.cf_domain_name,
                                info.asset_id,
                              )
                        }
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null // prevents looping
                          currentTarget.src = ImageNotFound
                        }}
                        alt={'Asset'}
                        style={{ height: '7rem' }}
                      />
                      <p className="card-text">{info.file_name}</p>
                    </CCol>
                  ))
                ) : (
                  <h5 className="no-data-text">Add Content to Asset Manager</h5>
                )}
              </CRow>
            </InfiniteScroll>
            <CFormText className="text-start text-black " style={{ marginLeft: '0.8rem' }}>
              {`Showing ${assetData?.length} of ${assetList?.total || 0}`}
            </CFormText>
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton
            style={{ marginRight: '2rem' }}
            color="info"
            className="text-white"
            onClick={() => showModal(false)}
          >
            Cancel
          </CButton>
          <CButton color="info" className="text-white" onClick={handleSelect}>
            Select
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default AssetManager
